// P1-021: Prepare phase layout — combines ServerRackPanel + AgentTerminal + OverloadMeter
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePhaseStore } from '@/shared/stores/phaseStore';
import { PreparePhase } from '../systems/PreparePhase';
import { Button } from '@/shared/ui/Button';
import { ServerRackPanel } from './ServerRackPanel';
import { AgentTerminal } from './AgentTerminal';
import { OverloadMeter } from './OverloadMeter';

export function PrepareLayout() {
  const updatePrepare = usePhaseStore((s) => s.updatePrepare);
  const navigate = useNavigate();
  const [errors, setErrors] = useState<string[]>([]);

  const handleFinalize = () => {
    const result = PreparePhase.finalize();
    if (result.success && result.prepareResult) {
      setErrors([]);
      updatePrepare(result.prepareResult);
      navigate('/hub');
    } else {
      setErrors(result.errors ?? ['Unknown error']);
    }
  };

  return (
    <div className="prepare-layout">
      <div className="prepare-layout__top">
        {/* Left: Hardware management */}
        <div className="prepare-layout__hardware">
          <ServerRackPanel />
        </div>

        {/* Right: Agent formation */}
        <div className="prepare-layout__agents">
          <AgentTerminal />
        </div>
      </div>

      {/* Overload meter */}
      <OverloadMeter />

      {/* Bottom: Error display + Confirm button */}
      <div className="prepare-layout__bottom">
        <div className="prepare-layout__error">
          {errors.map((err, idx) => (
            <div key={idx}>[ERROR] {err}</div>
          ))}
        </div>
        <Button variant="primary" onClick={handleFinalize}>
          确认出击
        </Button>
      </div>
    </div>
  );
}
